import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationProcessComponent } from './components/authentication-process/authentication-process.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthorizationFormComponent } from './components/authentication-process/authorization-form/authorization-form.component';
import { AcdSelectionFormComponent } from './components/authentication-process/acd-selection-form/acd-selection-form.component';
import { AuthenticationLoadingComponent } from './components/authentication-process/authentication-loading/authentication-loading.component';

const routes: Routes = [
   {
      path: '',
      redirectTo: 'authentication',
      pathMatch: 'full',
   },
   {
      path: 'authentication',
      component: AuthenticationProcessComponent,
      children: [
         { path: '', redirectTo: 'dataLoading', pathMatch: 'full' },
         { path: 'dataLoading', component: AuthenticationLoadingComponent },
         { path: 'authorization', component: AuthorizationFormComponent },
         { path: 'acdSelection', component: AcdSelectionFormComponent },
      ],
   },
   {
      path: 'dashboard',
      component: DashboardComponent,
   },
];

@NgModule({
   imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
   exports: [RouterModule],
})
export class AppRoutingModule {}
